// extracted by mini-css-extract-plugin
export default {"ReportSummaryContent":"ReportSummaryContent_ReportSummaryContent__DgqT-","content":"ReportSummaryContent_content__qyCG1"};